import { SearchType } from '../constants';
import type { SearchSuggestion } from '../contracts';
import { TextSearchSuggestion } from '../contracts/SearchSuggestion';
import { highlightText } from '../utils';

type OwnProps = {
  data: SearchSuggestion[];
  inputValue?: string;
  searchType?: SearchType;
};

export default function normalizeFetchedSuggestions({
  data,
  inputValue = '',
  searchType = SearchType.TextSearch
}: OwnProps): TextSearchSuggestion[] {
  if (!data) return [];

  return data.map(({ text, ...rest }, index) => ({
    ...rest,
    searchType,
    suggestionIndex: index,
    text,
    highlightedText: highlightText(text, inputValue)
  }));
}
